module.exports = __webpack_public_path__ + "img/p-07.0cffcde9.webp";